import { Popper } from "@mui/material";

// this defines the popup box that contains the items to be selected from;
// it is redefined here to make it wider than the input field to accomodate
// the item name *and* the description, though only the item name is shown
// in the input box
export function WideSelectPopper({ style, ...props }) {
  return <Popper {...props} placement="bottom-start" sx={{ width: "50em" }} />;
}
